'use strict';

import permissions from '@/assets/js/api/functions';

export default {
    namespaced: true,
    state: {
        permissions: [],
        groupedPermissions: [],
        groups: [],
        subgroups: [],
        actionkeys: [],
        userActionkeys: [],
        moduleCount: {}
    },
    getters: {
        getPermissions: (state) => state.permissions,
        getGroupedPermissions: (state) => state.groupedPermissions,
        getGroups: (state) => state.groups,
        getSubgroups: (state) => state.subgroups,
        getActionKeys: (state) => state.actionkeys,
        getUserActionKeys: (state) => state.userActionkeys,
        getModuleCount: (state) => state.moduleCount
    },
    mutations: {
        SET_PERMISSIONS(state, value) {
            state.permissions = value;
        },

        SET_GROUPED_PERMISSIONS(state, value) {
            state.groupedPermissions = value;
        },

        SET_GROUPS(state, value) {
            state.groups = value;
        },

        SET_SUBGROUPS(state, value) {
            state.subgroups = value;
        },

        SET_ACTION_KEYS(state, value) {
            state.actionkeys = value;
        },

        SET_USER_ACTION_KEYS(state, value) {
            state.userActionkeys = value;
        },

        SET_MODULE_COUNT(state, value) {
            state.moduleCount = value;
        }
    },
    actions: {
        async fetchPermissions(context, payload) {
            const { filter, config } = payload || {};
            return new Promise((resolve, reject) => {
                permissions
                    .getData({
                        to: '/options/permissions',
                        config
                    })
                    .then((response) => {
                        let res = response.data;
                        let data = [];

                        if (filter !== undefined) {
                            filter.map((userPermission) => {
                                Object.values(res).map((permission) => {
                                    if (permission.action_key == userPermission) {
                                        //console.log(permission);
                                        data.push(permission);
                                    }
                                });
                            });
                        } else {
                            data = res;
                        }

                        const groups = [
                            ...new Set(
                                data.map((permission) => {
                                    return permission.group;
                                })
                            )
                        ];

                        const sub_groups = [
                            ...new Set(
                                data.map((permission) => {
                                    return permission.sub_group;
                                })
                            )
                        ];

                        context.commit('SET_GROUPS', groups);
                        context.commit('SET_SUBGROUPS', sub_groups);

                        let moduleCount = {};

                        let moduleTotal = Object.values(data).reduce(function (sums, entry) {
                            sums[entry.group + '-' + entry.sub_group] = (sums[entry.group + '-' + entry.sub_group] || 0) + 1;
                            sums[entry.group] = (sums[entry.group] || 0) + 1;
                            moduleCount[entry.group + '-' + entry.sub_group] = 0;
                            moduleCount[entry.group] = 0;
                            return sums;
                        }, {});

                        let actionkeys = [];
                        const groupedPermissions = groups.map((group) => {
                            const results_sub_groups = sub_groups.reduce((results_sub_groups, sub_group) => {
                                const results_permission = data.reduce((results_permission, permission) => {
                                    if (permission.sub_group == sub_group && permission.group == group) {
                                        results_permission.push({
                                            value: permission.action_key,
                                            text: permission.description
                                        });
                                        actionkeys.push(permission.action_key);

                                        if (context.state.userActionkeys.indexOf(permission.action_key) !== -1) {
                                            moduleCount[group + '-' + sub_group] = (moduleCount[group + '-' + sub_group] || 0) + 1;
                                            moduleCount[group] = (moduleCount[group] || 0) + 1;
                                        }
                                    }
                                    return [...new Set(results_permission)];
                                }, []);

                                if (results_permission.length != 0) {
                                    results_sub_groups.push({ [sub_group]: results_permission });
                                }
                                //console.log('sub_group', sub_group, sub_group_count);
                                return results_sub_groups;
                            }, []);

                            return { [group]: results_sub_groups };
                        });

                        const filterActionKeys = actionkeys.filter(function (item) {
                            if (context.state.userActionkeys.indexOf(item) !== -1) return item;
                        });

                        context.commit('SET_MODULE_COUNT', {
                            count: moduleCount,
                            total: moduleTotal
                        });
                        context.commit('SET_USER_ACTION_KEYS', filterActionKeys);
                        context.commit('SET_ACTION_KEYS', actionkeys);
                        context.commit('SET_PERMISSIONS', data);
                        context.commit('SET_GROUPED_PERMISSIONS', groupedPermissions);

                        resolve({
                            groupedPermissions: groupedPermissions,
                            permissions: data
                        });
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.commit('SET_PERMISSIONS', []);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        },
        async updateRoles(context, payload) {
            return new Promise((resolve, reject) => {
                var data = new Array();

                Object.keys(payload).map((role_id) => {
                    var x = {};
                    x['role_id'] = role_id;
                    x['permissions'] = Object.values(payload[role_id]);

                    data.push(x);
                });

                const params = {
                    roles: data
                };

                permissions
                    .getData({ to: '/roles/permissions', params })
                    .then((response) => {
                        resolve(response);
                    })
                    .catch((error) => {
                        // console.log(error);
                        context.dispatch('error', error, { root: true });
                        reject(error);
                    });
            });
        }
    }
};
